import { render, staticRenderFns } from "./TireSizeStep.vue?vue&type=template&id=5720f2f4"
import script from "./TireSizeStep.vue?vue&type=script&lang=ts"
export * from "./TireSizeStep.vue?vue&type=script&lang=ts"
import style0 from "./TireSizeStep.vue?vue&type=style&index=0&id=5720f2f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports